import type { ConnectionPhase } from "./signaling-client.js";
import { strings } from "./strings.js";

const CONNECTION_MESSAGES: Partial<Record<ConnectionPhase, string>> = {
  connecting: strings.connection.connecting,
  "lna-prompt-pending": strings.connection.lnaPromptPending,
  reconnecting: strings.connection.reconnecting,
  "reconnect-escalated": strings.connection.reconnectEscalated,
};

export function connectionBannerMessage(phase: ConnectionPhase): string {
  return CONNECTION_MESSAGES[phase] ?? strings.connection.checking;
}
